module.exports = __webpack_public_path__ + "img/lightning_elemental_small.0f7607af.png";